// extracted by mini-css-extract-plugin
export default {"message":"AccountStatusCalloutMessage-message-904d3346f44edef8685eb3e946b7df66"};